module.exports = __webpack_public_path__ + "media/images/mobile-view-1440-4c8fecaac2e482ddf49851fd8d0c762a.svg";